define("media/components/media/table", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object"], function (_exports, _component, _templateFactory, _component2, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Media::Table::SortableColumns @currentGroup={{@currentGroup}} @data={{@visibleMediaItems}} as |sortable|>
    <div class="o--container cMT--container" {{did-insert this.addTableShadows}} {{on "scroll" this.addTableShadows}}>
      <div class="cMT--tableWrapper">
        {{! Table Header }}
        <div class="cMT--thead">
          <table class="o--table o--table--sort u--m__b__0">
            <thead>
              <tr>
                {{! Checkbox }}
                <th class="cMT--th--checkbox" {{on "click" @toggleSelectAll}}>
                  {{#if @allVisibleMediaItemsSelected}}
                    {{svg-jar "verified" class="o--icon--md o--icon--light o--table__checkbox is--checked"}}
                  {{else}}
                    {{svg-jar "verified" class="o--icon--md o--icon--light o--table__checkbox"}}
                  {{/if}}
                </th>
                {{! Image }}
                <th class="cMT--th--image"></th>
                {{! Starred }}
                <th class="cMT--th--starred"></th>
                {{! Name }}
                <sortable.th
                  class="cMT--th--name"
                  @field="originalFilename" 
                  @name={{t "shared_words.name"}} 
                />
                {{! Labels }}
                <th class="cMT--th--labels">
                  <span class="u--float--left">
                    {{t "media_items.metadata.media_labels"}}
                  </span>
                </th>
                {{! Notes }}
                <th class="cMT--th--notes">
                  <span class="u--float--left">
                    {{t "media_items.metadata.media_notes"}}
                  </span>
                </th>
                {{! Post Count }}
                <sortable.th 
                  class="cMT--th--count"
                  @field="postCount" 
                  @name={{t "media_items.metadata.media_post_count"}} 
                />
                {{! Upload Date }}
                <sortable.th
                  class="cMT--th--date u--text--center"
                  @field="createdTime"
                  @name={{t "media_items.metadata.media_upload"}}
                />
                {{! Size }}
                <sortable.th
                  class="cMT--th--size"
                  @field="fileSize"
                  @name={{t "media_items.metadata.media_size"}}
                />
              </tr>
            </thead>
          </table>
        </div>
        {{! Table Body }}
        <div class="cMT--tbody">
          <table class="o--table o--table--sort o--table--hover u--m__b__0">
            <tbody>
              {{#each sortable.sortedItems as |mediaItem|}}
                <Media::Table::MetaData
                  @mediaItem={{mediaItem}}
                  @queryLabels={{@queryLabels}}
                  @searchString={{@mediaNotesSearchString}}
                  @selectedAssets={{@selectedAssets}}
                  @addSelection={{@addSelection}}
                  @removeSelection={{@removeSelection}}
                  @removeStarred={{@removeStarred}}
                  @addStarred={{@addStarred}}
                  @openAssetModal={{@openAssetModal}}
                />
              {{/each}}
            </tbody>
          </table>
          <div class="cMT--tbody__footer">
            {{#if @queryLoadingMore}}
              <span class="o--btn u--text--light o--btn--block">
                {{t "shared_words.loading"}}
              </span>
            {{else if @canLoadMore}}
              <a class="o--btn--lg o--btn--outline o--btn--block u--text--hl" {{on "click" @loadMore}}>
                {{t "shared_phrases.load_more"}}
              </a>
            {{else}}
              <span class="o--btn u--text--light o--btn--block">
                {{t "shared_phrases.no_more"}}
              </span>
            {{/if}}
          </div>
        </div>
      </div>
    </div>
    <div class="cMT--shadow--left"></div>
    <div class="cMT--shadow--right"></div>
  </Media::Table::SortableColumns>
  */
  {
    "id": "D1XRgZM/",
    "block": "[[[8,[39,0],null,[[\"@currentGroup\",\"@data\"],[[30,1],[30,2]]],[[\"default\"],[[[[1,\"\\n  \"],[11,0],[24,0,\"o--container cMT--container\"],[4,[38,1],[[30,0,[\"addTableShadows\"]]],null],[4,[38,2],[\"scroll\",[30,0,[\"addTableShadows\"]]],null],[12],[1,\"\\n    \"],[10,0],[14,0,\"cMT--tableWrapper\"],[12],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cMT--thead\"],[12],[1,\"\\n        \"],[10,\"table\"],[14,0,\"o--table o--table--sort u--m__b__0\"],[12],[1,\"\\n          \"],[10,\"thead\"],[12],[1,\"\\n            \"],[10,\"tr\"],[12],[1,\"\\n\"],[1,\"              \"],[11,\"th\"],[24,0,\"cMT--th--checkbox\"],[4,[38,2],[\"click\",[30,4]],null],[12],[1,\"\\n\"],[41,[30,5],[[[1,\"                  \"],[1,[28,[35,4],[\"verified\"],[[\"class\"],[\"o--icon--md o--icon--light o--table__checkbox is--checked\"]]]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[1,[28,[35,4],[\"verified\"],[[\"class\"],[\"o--icon--md o--icon--light o--table__checkbox\"]]]],[1,\"\\n\"]],[]]],[1,\"              \"],[13],[1,\"\\n\"],[1,\"              \"],[10,\"th\"],[14,0,\"cMT--th--image\"],[12],[13],[1,\"\\n\"],[1,\"              \"],[10,\"th\"],[14,0,\"cMT--th--starred\"],[12],[13],[1,\"\\n\"],[1,\"              \"],[8,[30,3,[\"th\"]],[[24,0,\"cMT--th--name\"]],[[\"@field\",\"@name\"],[\"originalFilename\",[28,[37,5],[\"shared_words.name\"],null]]],null],[1,\"\\n\"],[1,\"              \"],[10,\"th\"],[14,0,\"cMT--th--labels\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"u--float--left\"],[12],[1,\"\\n                  \"],[1,[28,[35,5],[\"media_items.metadata.media_labels\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"],[1,\"              \"],[10,\"th\"],[14,0,\"cMT--th--notes\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"u--float--left\"],[12],[1,\"\\n                  \"],[1,[28,[35,5],[\"media_items.metadata.media_notes\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"],[1,\"              \"],[8,[30,3,[\"th\"]],[[24,0,\"cMT--th--count\"]],[[\"@field\",\"@name\"],[\"postCount\",[28,[37,5],[\"media_items.metadata.media_post_count\"],null]]],null],[1,\"\\n\"],[1,\"              \"],[8,[30,3,[\"th\"]],[[24,0,\"cMT--th--date u--text--center\"]],[[\"@field\",\"@name\"],[\"createdTime\",[28,[37,5],[\"media_items.metadata.media_upload\"],null]]],null],[1,\"\\n\"],[1,\"              \"],[8,[30,3,[\"th\"]],[[24,0,\"cMT--th--size\"]],[[\"@field\",\"@name\"],[\"fileSize\",[28,[37,5],[\"media_items.metadata.media_size\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cMT--tbody\"],[12],[1,\"\\n        \"],[10,\"table\"],[14,0,\"o--table o--table--sort o--table--hover u--m__b__0\"],[12],[1,\"\\n          \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,3,[\"sortedItems\"]]],null]],null],null,[[[1,\"              \"],[8,[39,8],null,[[\"@mediaItem\",\"@queryLabels\",\"@searchString\",\"@selectedAssets\",\"@addSelection\",\"@removeSelection\",\"@removeStarred\",\"@addStarred\",\"@openAssetModal\"],[[30,6],[30,7],[30,8],[30,9],[30,10],[30,11],[30,12],[30,13],[30,14]]],null],[1,\"\\n\"]],[6]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"cMT--tbody__footer\"],[12],[1,\"\\n\"],[41,[30,15],[[[1,\"            \"],[10,1],[14,0,\"o--btn u--text--light o--btn--block\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"shared_words.loading\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[41,[30,16],[[[1,\"            \"],[11,3],[24,0,\"o--btn--lg o--btn--outline o--btn--block u--text--hl\"],[4,[38,2],[\"click\",[30,17]],null],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"shared_phrases.load_more\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,1],[14,0,\"o--btn u--text--light o--btn--block\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"shared_phrases.no_more\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]],[]]],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"cMT--shadow--left\"],[12],[13],[1,\"\\n  \"],[10,0],[14,0,\"cMT--shadow--right\"],[12],[13],[1,\"\\n\"]],[3]]]]]],[\"@currentGroup\",\"@visibleMediaItems\",\"sortable\",\"@toggleSelectAll\",\"@allVisibleMediaItemsSelected\",\"mediaItem\",\"@queryLabels\",\"@mediaNotesSearchString\",\"@selectedAssets\",\"@addSelection\",\"@removeSelection\",\"@removeStarred\",\"@addStarred\",\"@openAssetModal\",\"@queryLoadingMore\",\"@canLoadMore\",\"@loadMore\"],false,[\"media/table/sortable-columns\",\"did-insert\",\"on\",\"if\",\"svg-jar\",\"t\",\"each\",\"-track-array\",\"media/table/meta-data\"]]",
    "moduleName": "media/components/media/table.hbs",
    "isStrictMode": false
  });

  let TableComponent = (_class = class TableComponent extends _component2.default {
    addTableShadows() {
      const wrapper = document.querySelector('.cMT--container');
      if (wrapper === null) return;
      const horizontalOverflow = wrapper.scrollWidth - wrapper.offsetWidth;

      if (horizontalOverflow > 0) {
        const leftShadow = document.querySelector('.cMT--shadow--left');
        const rightShadow = document.querySelector('.cMT--shadow--right');
        if (leftShadow === null || rightShadow === null) return;
        const shadowClass = 'has--shadow';

        if (wrapper.scrollLeft === 0) {
          rightShadow.classList.add(shadowClass);
          leftShadow.classList.remove(shadowClass);
        } else if (wrapper.scrollLeft === horizontalOverflow) {
          rightShadow.classList.remove(shadowClass);
          leftShadow.classList.add(shadowClass);
        } else {
          rightShadow.classList.add(shadowClass);
          leftShadow.classList.add(shadowClass);
        }
      }
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "addTableShadows", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addTableShadows"), _class.prototype)), _class);
  _exports.default = TableComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TableComponent);
});